{
  "appName": "NRG CMX",
  "loading": "Loading…",
  "retry": "Retry",
  "cancel": "Cancel",
  "save": "Save",
  "search": "Search",
  "noResults": "No results",
  "pagination": {
    "root": "pagination",
    "rootFor": "{{table}} pagination",
    "first": "First page",
    "previous": "Previous page",
    "next": "Next page",
    "last": "Last page",
    "page": "Page {{page}} of {{totalPages}}",
    "range": "{{start}}–{{end}} of {{total}}",
    "compact": "{{page}} / {{totalPages}}",
    "rowsPerPage": "Rows per page"
  },
  "logout": "Log out",
  "forbidden": {
    "title": "Access denied",
    "body": "Your account doesn’t have access to NRG CMX.",
    "signedInAs": "Signed in as {{email}}",
    "contact": "Contact your organisation administrator to request access."
  },
  "topbar": {
    "search": {
      "placeholder": "Search stations, locations, pages…",
      "label": "Global search",
      "shortcutHint": "{{key}} K",
      "openLabel": "Open search",
      "clearLabel": "Clear search",
      "dialogTitle": "Search",
      "resultsLabel": "Search results",
      "minChars": "Type at least {{min}} characters to search.",
      "searching": "Searching…",
      "empty": "No matches for “{{query}}”.",
      "error": "Some sources couldn’t be searched right now — results may be incomplete.",
      "stationCount_one": "{{count}} charging station",
      "stationCount_other": "{{count}} charging stations",
      "groups": {
        "pages": "Pages",
        "stations": "Charging stations",
        "locations": "Locations",
        "meteringPoints": "Metering points"
      }
    },
    "language": {
      "label": "Display language",
      "nl": "NL",
      "en": "EN",
      "ariaLabel": "Switch language to {{language}}"
    },
    "notifications": {
      "label": "Notifications ({{count}} unread)",
      "title": "Notifications",
      "subtitle": "Live alerts across your portfolio",
      "empty": "You're all caught up.",
      "markAllRead": "Mark all as read",
      "items": {
        "erasmus-mc-over-threshold": {
          "title": "Erasmus MC consumption over threshold",
          "description": "Live load 149 kW exceeds the 130 kW cap."
        },
        "equinix-am4-grid-spike": {
          "title": "Equinix AM4 grid spike",
          "description": "Net import touched 213 kW for 12 minutes."
        },
        "ing-csrd-attention": {
          "title": "ING headquarters CSRD attention",
          "description": "Three CSRD metrics need an update before audit."
        },
        "almere-pv-underperform": {
          "title": "Almere PV underperforming",
          "description": "Two strings sit 18% below the daily forecast."
        },
        "noordereiland-meter-stale": {
          "title": "Noordereiland meter offline",
          "description": "Logger #4 has not reported for 22 minutes."
        },
        "rotterdam-port-permit-due": {
          "title": "Rotterdam Port permit due",
          "description": "Renewal window closes in 6 days."
        },
        "leiden-bess-firmware": {
          "title": "Leiden BESS firmware available",
          "description": "Vendor pushed a routine update - safe to schedule."
        }
      }
    },
    "breadcrumb": {
      "ariaLabel": "Breadcrumb",
      "cpoAnalytics": "CPO Analytics",
      "qrPayment": "QR Payment",
      "alerts": "Alerts",
      "helpdesk": "Helpdesk",
      "billing": "Finance",
      "splitBilling": "Reimbursement split",
      "invoices": "Invoices",
      "fees": "Fees",
      "oda": "ODA metering"
    }
  },
  "nav": {
    "sections": {
      "cpms": "CPMS",
      "energy": "Energy",
      "support": "Support",
      "billing": "Finance"
    },
    "oda": "ODA metering",
    "cpoAnalytics": "CPO Analytics",
    "qrPayment": "QR Payment",
    "alerts": "Alerts",
    "helpdesk": "Helpdesk",
    "splitBilling": "Reimbursement split",
    "invoices": "Invoices",
    "checklist": "Checklist",
    "fees": "Fees"
  },
  "sidebar": {
    "access": {
      "domain": "Domain",
      "tenant": "Tenant",
      "organisation": "Organisation"
    }
  },
  "combobox": {
    "more": "+{{count}} more - keep typing to narrow"
  }
}
